module.exports = "/dist/cbab8a7bf67c79ebd13a59d1fcde2026.png";